import type { Sprinkles } from '../theme/sprinkles.css'
import { sprinkles } from '../theme/sprinkles.css'

type StackPatternParams = {
  direction?: 'row' | 'column'
} & Omit<Sprinkles, 'display' | 'flexDirection'>

export const stack = ({ direction = 'column', ...params }: StackPatternParams) => {
  return sprinkles({ display: 'flex', flexDirection: direction, ...params })
}

type DirectedStackPatternParams = Omit<StackPatternParams, 'direction'>

export const xStack = (params?: DirectedStackPatternParams) => {
  return stack({ direction: 'row', alignItems: 'center', ...params })
}

export const yStack = (params?: DirectedStackPatternParams) => {
  return stack({ direction: 'column', ...params })
}
